import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromConfiguration from '@appStore/configuration/reducers/configuration.reducer';
import * as fromRoot from '../../../reducers';

// feature state
export interface ConfigurationState {
  configuration: fromConfiguration.State;
}

export interface State extends fromRoot.State {
  configuration: ConfigurationState;
}

// reducers
export const reducers: ActionReducerMap<ConfigurationState> = {
  configuration: fromConfiguration.reducer
};

export const getState = createFeatureSelector<ConfigurationState>('configuration');

export const getConfigurationState = createSelector(
  getState,
  (state: ConfigurationState) => state.configuration
);
export const getApiConfiguration = createSelector(
  getConfigurationState,
  fromConfiguration.getApiConfigurationState
);
export const getApiConfigurationLoaded = createSelector(
  getConfigurationState,
  fromConfiguration.getApiConfigurationLoaded
);

export const getMenuConfiguration = createSelector(
  getConfigurationState,
  fromConfiguration.getMenuConfigurationState
);
export const getMenuConfigurationLoaded = createSelector(
  getConfigurationState,
  fromConfiguration.getMenuConfigurationLoaded
);

export const getIsAuthSetup = createSelector(
  getConfigurationState,
  fromConfiguration.getIsAuthSetup
);
export const getActiveClientId = createSelector(
  getConfigurationState,
  fromConfiguration.getActiveClientId
);

export const getPermissions = createSelector(
  getConfigurationState,
  fromConfiguration.getPermissions
);
export const getPermissionsLoading = createSelector(
  getConfigurationState,
  fromConfiguration.getPermissionsLoading
);
export const getPermissionsLoaded = createSelector(
  getConfigurationState,
  fromConfiguration.getPermissionsLoaded
);
export const getPermissionsWithLoaded = createSelector(
  getState,
  (cState: ConfigurationState) => {
    return { permissions: cState.configuration.permissions, loaded: cState.configuration.permissionsLoaded };
  }
);

export const getSystemContent = createSelector(
  getConfigurationState,
  fromConfiguration.getSystemContent
);

export const getSystemContentLoaded = createSelector(
  getConfigurationState,
  fromConfiguration.getSystemContentLoaded
);

export const getPrognosisYears = createSelector(
  getApiConfiguration,
  (cState): number[] => {
    let prognosisYears = [] as number[];
    prognosisYears.push(cState.contracts_prognosis_year);
    prognosisYears.push(cState.contracts_prognosis_year - 1);
    return prognosisYears;
  }
);

// Price model 2025
export const getPrognosisYear = createSelector(
  getApiConfiguration,
  (cState): number => {
    return cState.contracts_prognosis_year;
  }
);

export const getPrognosisYearsPrivate = createSelector(
  getApiConfiguration,
  (cState): number[] => {
    let prognosisYearsPrivate = [] as number[];
    prognosisYearsPrivate.push(cState.contracts_prognosis_year_private);
    prognosisYearsPrivate.push(cState.contracts_prognosis_year_private - 1);
    return prognosisYearsPrivate;
  }
);

// Price model 2025
export const getPrognosisYearPrivate = createSelector(
  getApiConfiguration,
  (cState): number => {
    return cState.contracts_prognosis_year_private;
  }
);

export const getErrorRefreshPerformed = createSelector(
  getConfigurationState,
  fromConfiguration.getErrorRefreshPerformed
);
